// Montant affiche au client : TOUJOURS au centime pres (CTO, 2026-10-06 — « si c'est
// 58,33 € il faut afficher 58,33 €, pas 58 »). Format de la langue de la page (virgule ou
// point, separateur de milliers, place du symbole) et nombre de decimales propre a la
// devise (2 pour EUR/USD/HKD…, 0 pour le yen) — c'est Intl qui le sait, pas nous.
//
// `amount` est deja dans `currency` : la conversion depuis l'EUR se fait avant
// (fetchExchangeRate, utils/currencyUtils).

const toLocale = (lang?: string | null): string | undefined => {
  if (!lang) return undefined;
  const tag = String(lang).replace("_", "-");
  try {
    // Une locale invalide leve une RangeError : on retombe alors sur celle du navigateur.
    new Intl.NumberFormat(tag);
    return tag;
  } catch {
    return undefined;
  }
};

export const formatMoney = (
  amount: number | string | null | undefined,
  currency?: string | null,
  lang?: string | null,
): string => {
  const n = Number(amount);
  if (amount === null || amount === undefined || amount === "" || !Number.isFinite(n)) return "—";
  const code = String(currency || "EUR").toUpperCase();
  try {
    return new Intl.NumberFormat(toLocale(lang), { style: "currency", currency: code }).format(n);
  } catch {
    // Code devise inconnu d'Intl : le montant au centime, puis le code.
    return `${n.toFixed(2)} ${code}`;
  }
};

export default formatMoney;
